import request from '@/utils/request'
export default {
  // 新增新人工具包
  addOrEditPackage(method,data) {
    return request({
      url: '/system/package',
      method,
      data
    })
  },

  // 删除新人工具包
  delPackage(id) {
    return request({
      url: `/system/package/${id}`,
      method: 'delete',
    })
  },

  // 获取新人工具包详细信息
  findPackage(id) {
    return request({
      url: `/system/package/${id}`,
      method: 'get'
    })
  },

  // 点击新增新人工具包之前，需要查出当前新人工具包的最大数量，便于回显
  getCountPackage() {
    return request({
      url: '/system/package/getCount',
      method: 'get'
    })
  },

  // 查询新人工具包列表
  packageList() {
    return request({
      url: '/system/package/list',
      method: 'get'
    })
  },


  // 新人工具包详情信息
  packageDetail(id) {
    return request({
      url: `/system/detail/${id}`,
      method: 'get'
    })
  },

  // 新增修改工具包详情
  addOrEditPackageDetail(method, data) {
    return request({
      url: '/system/detail',
      method: method,
      data
    })
  },

  // 删除工具包详情
  delPackageDetail(id) {
    return request({
      url:`/system/detail/${id}`,
      method:'delete'
    })
  }
}
